module.exports = __webpack_public_path__ + "img/bag-check.8037e3dc.svg";